var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2286 1.75L0.771429 1.75C0.34538 1.75 6.13076e-08 1.41421 0 0.999999C-6.13076e-08 0.585788 0.34538 0.250001 0.771429 0.250001L17.2286 0.25C17.6546 0.25 18 0.585786 18 0.999999C18 1.41421 17.6546 1.75 17.2286 1.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2286 7.75L0.771429 7.75C0.34538 7.75 6.13076e-08 7.41421 0 7C-6.13076e-08 6.58579 0.34538 6.25 0.771429 6.25L17.2286 6.25C17.6546 6.25 18 6.58579 18 7C18 7.41421 17.6546 7.75 17.2286 7.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2286 13.75L0.771429 13.75C0.34538 13.75 6.13076e-08 13.4142 0 13C-6.13076e-08 12.5858 0.34538 12.25 0.771429 12.25L17.2286 12.25C17.6546 12.25 18 12.5858 18 13C18 13.4142 17.6546 13.75 17.2286 13.75Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.62998f9fe38984094690f1866faf55d9.svg";
export { ForwardRef as ReactComponent };